import { matchPath } from 'react-router-dom';
import { RoutePath } from 'enums/Routes';

export const getExistingPath = (path: string): RoutePath | undefined =>
  Object.values(RoutePath).find((routePath) => {
    if (routePath === path) return true;
    return matchPath(routePath, path);
  });
